import MinedUpgradeCollection from "../../../model/upgrade/free/MinedUpgradeCollection";
import HeaderView from "../../common/HeaderView";
import Page from "../../framework/Page";
import ParentView from "../../framework/ParentView";
import MinedUpgradeView from "./MinedUpgradeView";

export default class MinedUpgradeCollectionView extends ParentView {
    /**
     * @param {string} parentId
     * @param {string} elementId 
     * @param {MinedUpgradeCollection} minedUpgradeCollection
     */
    constructor(parentId, elementId, minedUpgradeCollection) {
        super(parentId, elementId);

        /**
         * @constant
         * @type {MinedUpgradeCollection}
         */
        this.minedUpgradeCollection = minedUpgradeCollection;

        /**
         * @type {number}
         */
        this.displayedChangeCount = -1;

        /**
         * The max number of upgrades to represent in the UI
         * @constant
         * @type {number}
         */
        this.maxDisplayCount = 15; // ??? 

        /**
         * @constant
         * @type {MinedUpgradeView[]}
         */
        this.upgradeViews = [];

        this.addView(new HeaderView(this.elementId, this.elementId + '_header', 'Mined Upgrades'));

        for (let i = 0; i < this.maxDisplayCount; i++) {
            const upgradeView = new MinedUpgradeView(elementId, elementId + '_' + i, minedUpgradeCollection);
            this.upgradeViews.push(upgradeView);

            this.addView(upgradeView);
        }

        // The panel starts out as visible.
        this.setCurrentlyVisible(true);
    }

    /**
     * @override
     */
    initializeView() {

        // <div id="minedUpgradesPanel"></div>

        const parent = Page.getElement(this.parentId);
        Page.createElement('div', parent, this.elementId, null);

        super.initializeView();
    }

    updateView() {
        // Hide the panel if there are no upgrades
        /////this.setViewVisible(this.minedUpgradeCollection.upgrades.length > 0);

        super.updateView();
    }

    /**
     * @override
     */
    updateViewContents() {

        if (this.displayedChangeCount !== this.minedUpgradeCollection.changeCount) {
            this.displayedChangeCount = this.minedUpgradeCollection.changeCount;

            this.updateUpgrades();
        }

        super.updateViewContents();
    }
    
    /**
     * @private
     */
    updateUpgrades() {

        const upgrades = this.minedUpgradeCollection.upgrades;
        const size = Math.min(upgrades.length, this.maxDisplayCount);

        let i = 0;
        
        for (; i < size; i++) {
            if (i < this.upgradeViews.length) {
                this.upgradeViews[i].setUpgrade(upgrades[i]);
            }
        }

        // If there are more views than upgrades, then we need to nullify any upgrade references.
        for (; i < this.upgradeViews.length; i++) {
            this.upgradeViews[i].setUpgrade(null);
        }
    }
}